import React              from 'react';
import classNames         from 'classnames';
import * as PropTypes     from 'prop-types';
import { useTranslation } from 'react-i18next';

const SearchLine = (props) => {
  const {
          close,
          show,
          search,
          reset,
          resetTimeout,
        } = props;

  const [searchInput, setSearchInput] = React.useState('');
  const [pending, setPending]         = React.useState(false);
  const { t }                         = useTranslation();

  let timer = null;

  const onChange = (event) => {
    resetTimeout();

    if (!isSSR()) {
      clearTimeout(timer);
    }

    const { target: { value } } = event;

    setSearchInput(value);

    if (value !== '' && !isSSR()) {
      timer = setTimeout(() => {
        setPending(true);
        setTimeout(() => setPending(false), 2500);
      }, 500);
      search(decodeURI(value));
    }
  };

  const handleReset = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!pending) {
      setSearchInput('');
      reset();
    }
  };

  return (
    <div
      className={classNames(
        'searchLine',
        { 'show': show },
      )}
    >
      <input
        autoFocus={true}
        type={'text'}
        placeholder={`${t('client_search')}...`}
        onChange={onChange}
        value={searchInput}
      />
      {searchInput.trim() !== '' && (
        <span
          className={classNames(
            'reset',
            { 'spin': pending },
          )}
          onClick={handleReset}
        >
          <i className={pending ? 'ic-rotate' : 'ic-close'} />
        </span>)}
      <button
        className={'close'}
        onClick={close}
      >
        <i className={'ic-close'} />
      </button>
    </div>
  );
};

SearchLine.propTypes = {
  close:        PropTypes.func.isRequired,
  reset:        PropTypes.func.isRequired,
  resetTimeout: PropTypes.func.isRequired,
  search:       PropTypes.func.isRequired,
  show:         PropTypes.bool.isRequired,
};

export default SearchLine;